/* eslint-disable no-mixed-spaces-and-tabs */
import axios from 'axios';

import md5 from './md5';

axios.defaults.withCredentials = true;

axios.defaults.crossDomain = true;

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';

const devMode = process.env.NODE_ENV !== 'production';

const BASEURL_LUNA = devMode ? '/luna' : '//luna.58.com';
const BASEURL_ZP = devMode ? '/zp' : '//jianli.58.com';
const BASEURL_ZP_M = devMode ? '/m' : '//jianli.m.58.com';
const BASEURL_ZP_WEB = devMode ? '/web' : '//jlwebapp.58.com';

export const request = (method = 'GET', uri, params, option = {}) => {
    const config = {
        method,
        url: uri,

        ...option
    };
    config[method === 'GET' ? 'params' : 'data'] = params;
    return axios(config).then(
        (res) => res.data,
        (err) => {
            console.log('Err::', err);
            return Promise.reject(new Error(`网络错误 url:${uri}`));
        }
    );
};

const getSignData = (data, type = 'v2') => {
    const timestamp = new Date().getTime(); // 调用时间
    const keys = Object.keys(Object.assign(data, { timestamp })).sort();
    let str = '';
    keys.forEach((key) => {
        if (key !== 'sign') {
            str += `&${key}=${data[key]}`;
        }
    });
    str = str.substring(1);
    const sign = type === 'v2' ? md5(`${str}7jr73hs50s8g7l1m`) : md5(`${str}2k834u09wsdu899l`);
    return {
        ...data,
        sign
    };
};

export const api = {
    // luna.58.com
    saveDraft: (params) => request('POST', `${BASEURL_LUNA}/resume/draft/save`, getSignData(params)), // 保存草稿
    getDraft: (params) => request('GET', `${BASEURL_LUNA}/resume/draft/get`, params), // 获取草稿
    qwtDelivery: (params) => request('GET', `${BASEURL_LUNA}/api/clue/job/submit`, getSignData(params)), // 全网推异步投递简历


    // jianli.58.com
    checkMobile: (params) => request('GET', `${BASEURL_ZP}/resumeapi/mobilestate`, params), // 校验手机号
    getAreaInfo: (params) => request('GET', `${BASEURL_ZP}/resumecommon/city/zonebyname`, params), // 获取地域数据

    // jianli.m.58.com
    getCheckCode: (params) => request('GET', `${BASEURL_ZP_M}/resumecommon/getcaptcha`, params), // 获取验证码
    getPredata: (params) => request('GET', `${BASEURL_ZP_M}/resumepost/predata`, params), // 填充地域、职位等默认数据
    getResumeList: (params) => request('GET', `${BASEURL_ZP_M}/resumedetail/my/wx/list`, params), // 获取简历列表
    getResume: (params) => request('GET', `${BASEURL_ZP_M}/resumedetail/my/wx/${params.id}`, params), // 获取单个简历
    verifyCode: (params) => request('GET', `${BASEURL_ZP_M}/resumecommon/checkcaptcha`, params), // 校验验证码
    setPrivacy: (params) => request('POST', `${BASEURL_ZP_M}/userprivacy/postprivacy`, _urlEncode(params), {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}), // 设置隐私
    getPrivacy: (params) => request('GET', `${BASEURL_ZP_M}/userprivacy/getprivacy`, params),
    updateResume: (params) => request('GET', `${BASEURL_ZP_M}/resumeupdate/basicinfo/wx/update`, params), // 更新简历
    deliveryCheck: (params) => request('GET', `${BASEURL_ZP_M}/resumedelivery/api/check`, params), //
    saveResume: (params) => request('POST', `${BASEURL_ZP_M}/resumepost/micro?isminiprogram=true`, params), // 保存简历
    delivery: (params) => request('GET', `${BASEURL_ZP_M}/resumedelivery/api/process`, params), // 投递简历

    // jlwebapp.58.com
    getStaticData: () => request('GET', `${BASEURL_ZP_WEB}/resumepost/staticData`), // 获取静态数据
    getTargetCateIDs: () => request('GET', `${BASEURL_ZP_WEB}/resumepost/targetCateIDs`) // 获取职位数据
};

export default axios;


function _urlEncode(params) {
    if (typeof params === 'object') {
        return Object.keys(params)
            .map((key) => (
                `${encodeURIComponent(key)
					 }=${
					 encodeURIComponent(params[key])}`
            ))
            .join('&');
    } else {
        return params;
    }
}
